import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { DropdownDTO } from "../../../types/common/DropdownDTO";

export interface ModuleCategoryState {
  moduleCategoryDropdown: DropdownDTO[];
}

const initialState: ModuleCategoryState = {
  moduleCategoryDropdown: [],
};

export const moduleCategorySlice = createSlice({
  name: "moduleCategory",
  initialState,
  reducers: {
    /**
     * 🔹 Carga las categorías de módulo en el estado global
     */
    loadingModuleCategoryDropdown: (
      state,
      action: PayloadAction<DropdownDTO[]>
    ) => {
      state.moduleCategoryDropdown = action.payload;
    },
  },
});

export const { loadingModuleCategoryDropdown } =
  moduleCategorySlice.actions;

export default moduleCategorySlice.reducer;
